import React from 'react'
import { NavLink } from 'react-router-dom'
import { IconChevronRight, IconStar, IconStarFilled } from '@tabler/icons-react'
import classNames from 'classnames'

import { Button } from '@/components/buttons/Button'
import { getTestId, linkMatchesPath, neverActive } from './Sidebar.helpers'

export const SidebarSection = ({
  accessor,
  title,
  links = [],
  isOpen,
  onToggle,
  isSearching = false,
  favorites = [],
  favoritesSaving = false,
  onToggleFavorite,
  isFavoritesSection = false,
  currentSectionRef,
  currentPath,
}) => {
  const isCollapsible = !isFavoritesSection && !isSearching
  const containsCurrentPath =
    !isFavoritesSection && links.some((link) => linkMatchesPath(link, currentPath))

  return (
    <section
      className="balto-sidebar__section"
      data-testid={`sidebar-section-${accessor}`}
      ref={containsCurrentPath ? currentSectionRef : null}
    >
      <button
        data-testid={`sidebar-section-${accessor}-button`}
        type="button"
        className="balto-sidebar__section-header"
        disabled={!isCollapsible}
        aria-expanded={isOpen}
        onClick={() => onToggle(accessor)}
      >
        <div className="balto-sidebar__section-header-name">{title}</div>
        {isCollapsible && (
          <div className="balto-button basic balto-sidebar__collapse-button">
            <IconChevronRight className={classNames('accordion-icon', { expanded: isOpen })} />
          </div>
        )}
      </button>

      {isOpen && (
        <nav className="balto-sidebar__section-nav">
          {links.map((link) => {
            const isFavorite = favorites.includes(link.path)
            const linkTestId = isFavoritesSection
              ? `favorite-${getTestId(link.path)}`
              : getTestId(link.path)

            return (
              <div key={link.path} className="sidebar-link-row hidden-button-outer">
                <NavLink
                  data-testid={linkTestId}
                  to={link.path}
                  exact={link.exact}
                  isActive={isFavoritesSection ? neverActive : link.isActive}
                >
                  {link.icon}
                  {link.label}
                </NavLink>
                <Button
                  basic
                  small
                  square
                  className="hidden-button favorite-button"
                  icon={isFavorite ? <IconStarFilled className="fill-warning" /> : <IconStar />}
                  tooltip={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
                  aria-label={
                    isFavorite
                      ? `Remove ${link.label} from favorites`
                      : `Add ${link.label} to favorites`
                  }
                  data-testid={`${linkTestId}-favorite-toggle`}
                  disabled={favoritesSaving}
                  onClick={() => onToggleFavorite(link.path)}
                />
              </div>
            )
          })}
        </nav>
      )}
    </section>
  )
}
